<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{
                  driverCount > 1 || driverCount === 0
                    ? $tc("text.manageDrivers.title", 2)
                    : $tc("text.manageDrivers.title", 1)
                }}: {{ driverCount }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/chauffer.png" width="70%" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ branchCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div
              class="row align-items-center d-flex justify-content-center text-center section__row"
            >
              <button
                class="add__new__retainership_btn"
                @click="openDriverModal"
              >
                {{ $t("text.manageDrivers.addDriver") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="fullName"
                  :headerText="$t('text.manageDrivers.fullName')"
                ></e-column>
                <e-column
                  width="240"
                  field="email"
                  :headerText="$t('text.manageDrivers.email')"
                ></e-column>
                <e-column
                  width="180"
                  field="phone"
                  :headerText="$t('text.manageDrivers.phoneNo')"
                ></e-column>
                <e-column
                  width="700px"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <EditCompanyDriver :driver="driver"></EditCompanyDriver>
      <AddCompanyDriver :companyId="companyId"></AddCompanyDriver>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import EditCompanyDriver from "@/components/modals/Drivers/editDriver.vue";
import AddCompanyDriver from "@/components/modals/Drivers/addDriver.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Manage Drivers :: Epump Portal",
  name: "Manage Drivers",
  components: {
    MasterLayout,
    EditCompanyDriver,
    AddCompanyDriver,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      driver: "",
      driverCount: 0,
      company: null,
      companyId: this.$route.query.companyId,
      backgroundUrl,
      cardBackgroundUrl,
      zoneId: null,
      zoneName: "",
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div> 
                <a :href="'/Company/assigned-orders?id=' + data.id + '&companyId=' + $route.query.companyId" class="zone_action_buttons assign_branch" @click="manageDriversRoute($event, 'assignedOrders', data.id)">{{data.ordersButton}}</a> 
                <a :href="'/Company/assign-truck?id=' + data.id + '&companyId=' + $route.query.companyId" class="zone_action_buttons assign_branch other_button_1" @click="manageDriversRoute($event, 'assignTruck', data.id)">{{data.assignTruckButton}}</a> 
                <a :href="'/Company/assigned-truck?id=' + data.id + '&companyId=' + $route.query.companyId" class="zone_action_buttons assign_branch other_button_2" @click="manageDriversRoute($event, 'assignedTruck', data.id)">{{data.assignedTrucksButton}}</a> 
                <button class="zone_action_buttons edit_category" v-on:click="editDriver(data)">{{data.editButton}}</button> 
                <button class="zone_action_buttons delete_category" v-on:click="deleteDriver(data.id, data.companyId, data.text)">{{data.deleteButton}}</button> 
                </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              manageDriversRoute($event, route, id) {
                $event.preventDefault();
                this.$eventHub.$emit("manageDriversRoute", route, id);
              },
              editDriver(data) {
                this.$eventHub.$emit("setCompanyDriver", data);

                this.$modal.show("editDriver");
              },
              deleteDriver(id, companyId, text) {
                const remove = confirm(text[0]);
                if (!remove) {
                  return;
                }
                const data = { id, companyId };
                fetch(`${configObject.apiBaseUrl}/Delivery/CompanyDriver`, {
                  method: "DELETE",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      configObject.authConfig().headers.Authorization,
                  },
                  body: JSON.stringify(data),
                })
                  .then((res) => {
                    this.$toast.open({
                      message: text[1],
                      type: "success",
                      duration: 4000,
                    });
                    this.$eventHub.$emit("getDrivers");
                  })
                  .catch((error) => {
                    this.$toast.open({
                      message: text[2],
                      type: "error",
                      duration: 4000,
                    });
                  });
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getDrivers();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getDrivers();
    }
    this.$eventHub.$on("manageDriversRoute", (route, id) => {
      this.manageDriversRoute(route, id);
    });
    this.$eventHub.$on("setCompanyDriver", (driver) => {
      this.driver = driver;
    });
    this.$eventHub.$on("getDrivers", () => {
      this.getDrivers();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("manageDriversRoute");
    this.$eventHub.$off("setCompanyDriver");
    this.$eventHub.$off("getDrivers");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    manageDriversRoute(route, id) {
      if (this.$route.name == route) {
        return;
      }
      this.$router.push({
        name: route,
        query: {
          id,
          companyId: this.$route.query.companyId,
        },
      });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    openDriverModal() {
      this.$modal.show("addDriver");
    },
    getDrivers() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDrivers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.firstName > b.firstName
              ? 1
              : b.firstName > a.firstName
              ? -1
              : 0;
          });
          response.data.forEach((driver, index) => {
            driver.index = index + 1;
            driver.fullName = `${driver.firstName} ${driver.lastName}`;
            driver.ordersButton = this.$t("text.manageDrivers.assignedOrders");
            driver.assignTruckButton = this.$t(
              "text.manageDrivers.assignTruck"
            );
            driver.assignedTrucksButton = this.$t(
              "text.manageDrivers.assignedTrucks"
            );
            driver.editButton = this.$t("text.actionButtons.edit");
            driver.deleteButton = this.$t("text.actionButtons.delete");
            driver.text = [
              this.$t("text.manageDrivers.confirmDelete"),
              this.$t("text.manageDrivers.successfullyDeletedDriver"),
              this.$t("text.manageDrivers.failedToDelete"),
            ];
          });
          this.showLoader = false;
          this.driverCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .addDriver .v--modal-box.v--modal {
    /* top: 88px !important; */
    overflow-y: auto;
    margin: 0 auto;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
  }
  .editDriver .v--modal-box.v--modal {
    /* top: 88px !important; */
    overflow-y: auto;
    margin: 0 auto;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
  }
  .section__row {
    margin: 0 auto !important;
  }
}
</style>
